/**
 * GPT聊天机器人接口
 * 作者：陶璇
 * 时间：2023-8-14
 */
import request from "@/utils/request";
export const getChatGPT = (data) => {
    return request({
        url:'/oa_portal/oa/portal/Common/GetChatGPT',
        method: 'post',
        timeout:100000,
        data
    })
}

//获取登录人有权限的知识库
export function GetKmsByUserId(query) {
    return request({
        url: '/oa_ai/oa/ai/KmKms/GetKmsByUserId',
        method: 'Get',
        params: query
    })
}

// 获取助手列表
export function GetAssistantList(data) {
    return request({
        url: '/oa_ai/oa/ai/Assistant/GetAssistantList',
        method: 'Post',
        data
    })
}
//查询会话
export function GetSessionPages(session_id) {
    return request({
        url: '/oa_ai/oa/ai/Session/GetSessionPages',
        method: 'Post',
        data: session_id
    })
}

//查询模型
export function GetModelList(query) {
    return request({
        url: '/oa_ai/oa/ai/Model/GetModel',
        method: 'Get',
        params: query
    })
}

//查询会话记录
export function GetSessionRecord(query) {
    return request({
        url: '/oa_ai/oa/ai/Session/GetSessionRecord',
        method: 'Get',
        params: query
    })
}

//删除会话
export function DeleteSessionById(data) {
    return request({
        url: '/oa_ai/oa/ai/Session/DeleteSessionById',
        method: 'Post',
        data: data
    })
}

// 获取数据字典
export function GetDictList(data) {
    return request({
      url: `/oa_portal/oa/portal/DictData/GetDicts/` + data,
      method: 'GET',
    })
  }

  //保存会话
export function SaveSession(data) {
    return request({
        url: '/oa_ai/oa/ai/Session/SaveSession',
        method: 'Post',
        data: data
    })
}

//查询ai助手会话
export function GetAssistantSessionPages(data){
    return request({
        url:'/oa_ai/oa/ai/Session/GetAssistantSessionPages',
        method:'Post',
        data
    })
}

//查询ai助手
export function GetAiAssistantPageList(data){
    return request({
        url:'/oa_ai/oa/ai/Assistant/GetAiAssistantPageList',
        method:'Post',
        data
    })
}

//修改会话
export function UpdateSessionById(data){
    return request({
        url:'/oa_ai/oa/ai/Session/UpdateSessionById',
        method:'Post',
        data
    })
}

//上传文件
export function AIUploadFile(data){
    return request({
        url:'/oa_ai/oa/ai/Chat/UploadFile',
        method:'Post',
        data
    })
}